import gql from 'graphql-tag'

export default gql`mutation adminCreateUserResend($email: String!) {
	adminCreateUserResend(email: $email) {
		status
  }
}`
